<template>
  <PageContainer class="property-not-found">
    <!-- Worded for a deleted listing and another company's alike: the backend answers 404 to both, never saying which -->
    <EmptyState :icon="icon" :title="title" :description="description">
      <template #action>
        <Button variant="outline" size="medium" :to="portfolioRoute()">Back to Properties</Button>
      </template>
    </EmptyState>
  </PageContainer>
</template>

<script setup lang="ts">
import { Button, EmptyState, IconName, PageContainer } from '@tallo/design-system';
import { portfolioRoute } from '@tallo/investor/navigation';

/** A unit's wording unless told otherwise; a building's page names itself */
withDefaults(defineProps<{ title?: string; description?: string; icon?: IconName }>(), {
  title: 'This property no longer exists',
  description: 'It was deleted, or the link points at a property that was never here.',
  icon: 'home-03',
});
</script>

<style scoped lang="scss">
.property-not-found {
  display: flex;
  justify-content: center;
  padding-top: var(--t-spacing-xxl);
}
</style>
